import { BsCalendarDate } from "react-icons/bs";
import { CgProfile } from "react-icons/cg";
import { FaFileInvoiceDollar, FaNetworkWired, FaTachometerAlt, FaUserTie, FaIndustry, FaCamera, FaSortAmountDownAlt, FaRegAddressBook, FaStreetView } from "react-icons/fa";
import { GiKoholintEgg } from "react-icons/gi";
import { MdPolicy, MdWebhook, MdCall, MdLocationPin } from "react-icons/md";
import { TbReportAnalytics, TbRoute } from "react-icons/tb";

export const CompanyName = "DailyPostHub"

export const CompanyLogo = "https://www.dailyposthub.com/logo.png";

export const SidebarLinks = [
  {
    id:1,
    name: "Dashboard",
    icon: FaTachometerAlt,
    path: "/dashboard",
    role:["Admin"]
  },
   {
    id:2,
    name: "Dashboard",
    icon: FaTachometerAlt,
    path: "/contractordashboard",
    role:["contractor"]
  },
  {
    id:2,
    name: "Dashboard",
    icon: FaTachometerAlt,
    path: "/employeedashboard",
    role:["employee"]
  },
  {
    id:3,
    name: "Tenants",
    icon: MdWebhook,
    path: "/tenants",
    role:["Admin"]
  },
  {
    id:4,
    name: "My Profile",
    icon: CgProfile,
    path: "/contractor/profile",
    role:["contractor"]
  },
  {
    id:5,
    name: "Company",
    icon: FaIndustry,
    path: "/contractor/companyprofile",
    role:["contractor"]
  },
  {
    id:6,
    name: "My Profile",
    icon: CgProfile,
    path: "/employee/profile",
    role:["employee"]
  },
  {
    id:7,
    name: "Contractors",
    icon: CgProfile,
    path: "/contractors",
    role:["Admin"]
  },
  {
    id:8,
    name: "Employees",
    icon: FaUserTie,
    path: "/employees",
    role:["contractor"]
  },
  {
    id:9,
    name: "Tasks",
    icon: FaNetworkWired,
    path: "/tasks",
    role:["contractor"]
  },
   {
    id:10,
    name: "Routing",
    icon: TbRoute,
    path: "/routeInfo",
    role:["contractor"]
  },
  {
    id:11,
    name: "Daily Task Approval",
    icon: FaNetworkWired,
    path: "/employeetasks",
    role:["contractor"]
  },
  {
    id:12,
    name: "Salary Slips",
    icon: FaFileInvoiceDollar,
    path: "/payslip",
    role:["contractor"]
  },
  {
    id:13,
    name: "Reports",
    icon: TbReportAnalytics,
    path: "/reports",
    role:["contractor"]
  },
  {
    id:14,
    name: "Daily Tasks",
    icon: FaNetworkWired,
    path: "/mytask",
    role:["employee"]
  },
  {
    id:15,
    name: "Task History",
    icon: FaNetworkWired,
    path: "/taskhistory",
    role:["employee"]
  },
  {
    id:16,
    name: "Invoice",
    icon: TbReportAnalytics,
    path: "/invoice",
    role:["employee"]
  },
  {
    id:17,
    name: "Street",
    icon: FaStreetView,
    path: "/street",
    role:["employee"]
  },
  {
    id:18,
    name: "Add Route Address",
    icon: FaRegAddressBook,
    path: "/generateParcelAddress",
    role:["employee"]
  },
  {
    id:19,
    name: "Parcel Sorting",
    icon: FaSortAmountDownAlt,
    path: "/parcelsorting",
    role:["employee"]
  },
  {
    id:20,
    name: "Holidays",
    icon: GiKoholintEgg,
    path: "/holidays",
    role:["Admin", "contractor","employee"]
  },
  {
    id:21,
    name: "Rules & Regulations",
    icon: MdPolicy,
    path: "/rulesregulations",
    role:["Admin", "contractor","employee"]
  },
  {
    id:22,
    name: "Enquiry",
    icon: MdCall,
    path: "/enquiry",
    role:["Admin"]
  },
  {
    id:23,
    name: "Subscription",
    icon: BsCalendarDate,
    path: "/subscription",
    role:["contractor"]
  },
  // {
  //   id:23,
  //   name: "Location",
  //   icon: MdLocationPin,
  //   path: "/location",
  //   role:["contractor"]
  // },
]

export const TaskStatusEnum = {
    IN_PROGRESS: "In Progress",
    COMPLETED: "Completed",
    CANCELLED: "Cancelled",
  }

